var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "evenodd",
    d: "M8 0C3.578 0 0 3.576 0 8c0 1.668.509 3.211 1.413 4.537a.4.4 0 01.05.344L.65 15.6l2.663-.919a.399.399 0 01.343.044A7.952 7.952 0 008 16c4.424 0 8-3.576 8-8 0-4.424-3.576-8-8-8zM4.725 3.487l1.456 2.407-.606.6a.4.4 0 00-.063.481C6.439 8.577 7.534 9.824 9.07 10.5a.4.4 0 00.443-.081l.644-.644 2.35 1.469c-.26.585-.6.934-.987 1.137-.45.236-.999.28-1.625.15-1.253-.26-2.767-1.244-4-2.506C4.66 8.763 3.706 7.229 3.462 5.981c-.121-.624-.067-1.161.163-1.587.198-.367.535-.681 1.1-.907z"
  })));
}
export default SvgWhatsapp;